import { Link } from "react-router-dom";
import { Icon } from "@mui/material";
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import { Container } from '@mui/material';

const FancyDivider = () => {
  return (
			<MDBox className="cta-section" sx={{background : `url(${process.env.REACT_APP_PUBLIC_URL}/img/funfact-bg.jpg) center center`, minHeight:"300px", p:{xs:"40px", md:"80px", lg :"120px"}}}>
				<Container className="cta-section-item" sx={{position:"relative", p:{xs:"30px !important", md:"60px !important", lg :"90px !important"}}} >
					<MDTypography  variant="h1" sx={{fontSize : "26px", color:"#23346a", pb:3}}>NOUS SOMMES ICI</MDTypography>
					<MDTypography color="white" variant="h1" sx={{fontSize : "43px"}}>Parlez-nous de votre business, nous sommes prêts à résoudre. </MDTypography>
					<MDBox className="cta-shape">
						<svg style={{fill: "#0465ac", verticalAlign: "middle"}} width="325.000000pt" height="267.000000pt" viewBox="0 0 325.000000 267.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,267.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M0 1332 l0 -1332 920 0 919 0 39 53 c213 291 233 519 64 720 -101 119 -201 194 -617 462 -344 222 -452 297 -605 426 -320 268 -528 547 -676 906 -20 48 -38 90 -40 92 -2 2 -4 -595 -4 -1327z"></path></g></svg>
					</MDBox>
				</Container>
			</MDBox>
  );
};
export default FancyDivider;